import { openCloseToast } from "../../../../Global/actions";
//import { deleteCompanyApi, updateCompanyApi, createCompanyApi } from "../../../../../services/empresasApi";
import { deleteProfileApi, updateProfileApi, createProfileApi } from "../../../../../services/perfilesApi";
import { getEmpresas, loading, getPerfiles } from "../../General/actions";

export const doCreateEmpresa = (name, description) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await createProfileApi(name, description);
    if (request.status === 200) {
      dispatch(getPerfiles());
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Empresa creado con éxito",
        typeStyle: "success",
        displayTime: 5000
      }));
    } else {
      dispatch(getPerfiles());
      const res = await request.json();
      if (request.status === 403) {
        dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: res.Message,
          typeStyle: "warning",
          displayTime: 5000
        }));
      } else {
        dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: res.Message,
          typeStyle: "error",
          displayTime: 5000
        }));
      }
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al crear el empresa",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al crear el empresa",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doUpdateEmpresa = (idEmpresa, name, description, active) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await updateProfileApi(idEmpresa, name, description, active);
    if (request.status === 200) {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Empresa guardado con éxito",
        typeStyle: "success",
        displayTime: 5000
      }));
    } else {
      dispatch(getPerfiles());
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al guardar el empresa",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al guardar el empresa",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doDeleteEmpresa = (idEmpresa) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await deleteProfileApi(idEmpresa);
    if (request.status === 200) {
      dispatch(getPerfiles());
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Empresa eliminado con éxito",
        typeStyle: "success",
        displayTime: 5000
      }));
    } else {
      dispatch(getPerfiles());
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al eliminar el empresa",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al eliminar el empresa",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};
